import { render, staticRenderFns } from "./PaypalModal.vue?vue&type=template&id=4fc72fd2&"
import script from "./PaypalModal.vue?vue&type=script&lang=js&"
export * from "./PaypalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports